import { IconType } from 'react-icons';
import { TbAlignLeft, TbRefresh, TbUsers } from 'react-icons/tb';

export const PIPELINE_DISPLAYED_PROPERTY_KEYS = ['description', 'collaborators', 'updatedAt'] as const;

export type PipelineDisplayedPropertyKey = (typeof PIPELINE_DISPLAYED_PROPERTY_KEYS)[number];

export interface PipelineDisplayedPropertyOption {
    description: string;
    icon: IconType;
    key: PipelineDisplayedPropertyKey;
    label: string;
}

export const PIPELINE_DISPLAYED_PROPERTY_OPTIONS: PipelineDisplayedPropertyOption[] = [
    {
        description: 'A compact description of the Pipeline card.',
        icon: TbAlignLeft,
        key: 'description',
        label: 'Description',
    },
    {
        description: 'Members collaborating on the linked workspace resource.',
        icon: TbUsers,
        key: 'collaborators',
        label: 'Collaborators',
    },
    {
        description: 'When the linked workspace resource was last changed.',
        icon: TbRefresh,
        key: 'updatedAt',
        label: 'Updated',
    },
];

export const DEFAULT_PIPELINE_DISPLAYED_PROPERTIES: PipelineDisplayedPropertyKey[] = [
    ...PIPELINE_DISPLAYED_PROPERTY_KEYS,
];
